import App from './App.svelte';

const app = new App({
	target: document.querySelector('#databases-app'),
	props: {
	}
});

export default app;